import { gql } from '@apollo/client';

export const UPLOAD_CERTIFICATE_MUTATION = gql`
  mutation UploadCertificates(
    $entityId: String!
    $medicalInput: [Production_MedicalCertificateInputs!]!
  ) {
    production {
      entities {
        policy {
          production {
            uploadMedicalCertificateInputs(
              entityId: $entityId
              medicalInput: $medicalInput
            ) {
              Items {
                clauseText
                effectiveDate
                certificateInsuredPricingOptionMedical {
                  principalReference
                  reference
                  age
                  clauseID
                  coverCharges
                  coverChargesBasic
                  coverChargesSecondary
                  coverCost
                  coverCostBasic
                  coverCostSecondary
                  coverEffectiveFrom
                  coverEffectiveTo
                  coverFixedStamp
                  coverFixedStampBasic
                  coverFixedStampSecondary
                  coverGrossPremium
                  coverGrossPremiumBasic
                  coverGrossPremiumSecondary
                  coverMunicipalityTax
                  coverMunicipalityTaxBasic
                  coverMunicipalityTaxSecondary
                  coverNetPremiumBasic
                  coverNetPremiumSecondary
                  coverNetPremiumValue
                  coverNssf
                  coverProportionalStamp
                  coverProportionalStampBasic
                  coverProportionalStampSecondary
                  coverSumInsured
                  coverSumInsuredBasic
                  coverSumInsuredSecondary
                  coverTotalPremium
                  coverTotalPremiumBasic
                  coverTotalPremiumSecondary
                  coverTPAApplicableOn
                  coverTPAFees
                  coverTPAFeesAmount
                  coverTPAFeesBasic
                  coverTPAPercentage
                  coverTPASecondary
                  coverTPAType
                  excessOnClaimAmount
                  excessOnClaimDays
                  excessOnClaimPercentage
                  excessOnClaimType
                  isMain
                  isMandatory
                  planSpecificMedicalID
                  policyCoverID
                  policyID
                  policyMedicalID
                  policyPersonID
                  proposalID

                  sumInsuredIsAdditive
                }
                certificatePolicyMedical {
                  coversIDText
                  nbOfAdherent
                  nssf
                  class {
                    Id
                    Code
                    Title
                  }
                  policyID
                }
                certificatePolicyPersons {
                  addressType
                  cardNumber
                  continuity
                  dateOfBirth
                  exclusions
                  fullName
                  gender
                  grApplicable
                  grLimitDays
                  grRemainDays
                  grUserDays
                  insuredID
                  isPrincipal
                  isTaxable
                  limitOfCover
                  medicalDetailsID
                  orderNumber
                  ownerIsDifferent
                  passportNumber
                  percentage
                  personAddressID
                  personCode
                  personID
                  policyID
                  principalReference
                  profession
                  proposalID
                  referenceNumber
                  relation
                  remarks
                  smoker

                  tpaReference1
                  tpaReference2
                  type
                }
                certificatePolicyPlanCovers {
                  clauseEditable
                  clauseID
                  coverEffectiveFrom
                  coverEffectiveTo
                  coverPremium
                  coverPremiumArabic
                  coverPremiumArabicLetters
                  coverPremiumBasic
                  coverPremiumPercentage
                  coverPremiumSecondary
                  coverPremiumType
                  coverPremiumValue
                  coverSumInsured
                  coverSumInsuredArabic
                  coverSumInsuredArabicLetters
                  coverSumInsuredBasic
                  coverSumInsuredSecondary
                  emptyCoverSumInsured
                  excessOnClaimAmount
                  excessOnClaimDays
                  excessOnClaimPercentage
                  excessOnClaimType
                  isEditable
                  isMain
                  isMandatory
                  isNew
                  isRemoved
                  order
                  planCoverID
                  policyCoverID
                  policyID
                  proposalID

                  sumInsuredIsAdditive
                  sumInsuredPerClaim
                  totalExcessOnClaim
                  treatyID
                }
                certificatePricingOption {
                  pricingOptionCurrency {
                    Id
                    Symbol
                    Title
                    Code
                  }
                  basicPremium
                  basicPremiumBasic
                  basicPremiumSecondary
                  basicToPolicyRate
                  chargesAmount
                  chargesBasic
                  chargesPercentage
                  chargesSecondary
                  commissionToBasicRate
                  commissionToPolicyRate
                  fixedStamp
                  fixedStampCurrency {
                    Id
                    Code
                    Title
                  }
                  fixedStampAmount
                  fixedStampBasic
                  fixedStampSecondary
                  fixedStampToBasicRate
                  fixedStampToPolicyRate
                  grossPremium
                  grossPremiumBasic
                  municipalityTax
                  municipalityTaxAmount
                  municipalityTaxBasic
                  municipalityTaxSecondary
                  netPremium
                  netPremiumBasic
                  netPremiumSecondary
                  planToBasicRate
                  planToPolicyRate
                  policyCost
                  policyCostAmount
                  policyCostBasic
                  policyCostSecondary
                  policyID
                  policyToSecondaryRate
                  principalReference
                  proportionalStamp
                  proportionalStampAmount
                  proportionalStampBasic
                  proportionalStampSecondary
                  reinsuranceTax
                  reinsuranceTaxAmount

                  status
                  sumInsured
                  sumInsuredArabic
                  sumInsuredArabicLetters
                  sumInsuredBasic
                  sumInsuredLetters
                  sumInsuredSecondary
                  taxOnCommission
                  taxOnCommissionAmount
                  taxOnCommissionBasic
                  taxOnCommissionSecondary
                  totalCommission
                  totalCommissionBasic
                  totalCommissionSecondary
                  totalPremium
                  totalPremiumArabic
                  totalPremiumArabicLetters
                  totalPremiumBasic
                  totalPremiumLetters
                  totalPremiumSecondary
                  tpaFeesAmount
                  tpaFeesApplicableOn
                  tpaFeesPercentage
                  tpaFeesTotalAmount
                  tpaFeesTotalBasic
                  tpaFeesTotalSecondary
                  tpaFeesType
                }
              }
            }
          }
        }
      }
    }
  }
`;
